<template>
  <layout :showuserinfo="false" title="Tambah Hak Milik" :crumbs="crumbs">
    <z-page title="Pelarasan Cukai Tanah" :append-button="true">
      <w-form @submit.prevent="resit">
        <w-flex class="mt3">
          <div class="xs2">
            <p class="mr2">No. Resit</p>
          </div>
          <div class="xs10 mr3">
            <w-input
              v-model="form.noResit"
              placeholder="Sila Masukkan No Resit"
              :validators="[validators.required]"
              maxlength="30"
            ></w-input>
          </div>
        </w-flex>

        <div class="d-flex justify-end mt3">
          <w-button class="my1 mr0" type="submit" :loading="searching">
            Cari
          </w-button>
        </div>
      </w-form>
    </z-page>
    <br />
    <w-card title="Maklumat Pelarasan Cukai">
      <w-flex class="ma3" wrap>
        <div class="xs2 pa3">
          <h5 class="fw-semibold fs-2">No. Resit :</h5>
          <div class="fw-normal my1 fs-1 mt2">
            {{ senarai.noResit }}
          </div>
        </div>
        <div class="xs2 pa3">
          <h5 class="fw-semibold fs-2">Tarikh Bayar :</h5>
          <div class="fw-normal my1 fs-1 mt2">
            {{ senarai.tarikhBayar }}
          </div>
        </div>

        <div class="xs2 pa3">
          <h5 class="fw-semibold fs-2">No. Hakmilik :</h5>
          <div class="fw-normal my1 fs-1 mt2">
            {{ senarai.noHakmilik }}
          </div>
        </div>
      </w-flex>
      <hr />
      <w-flex class="justify-end">
        <w-button
          class="ml3"
          @click="tambahHakmilik = true"
          :disabled="senarai.noResit == null"
          :loading="searching"
        >
          Tambah Hakmilik
        </w-button>
      </w-flex>
      <w-card>
        <br>
        <w-flex class="justify-space-between">
          <h4>No Hakmilik: {{ senarai.noHakmilik }}</h4>
          <w-button
            class="ml3"
            @click="onPelarasan('1',this.senarai,newYear)"
            :disabled="senarai.noResit == null"
            :loading="searching"
          >
            Tambah Cukai Pelarasan
          </w-button>
        </w-flex>
        <table class="mb2 table-dashboard" width="100%">
          <thead>
            <tr>
              <!-- <td>No Hm</td> -->
              <td>Kod Akaun</td>
              <td>Butiran</td>
              <td>Amaun Debit (RM)</td>
              <td>Amaun Kredit (RM)</td>
            </tr>
          </thead>
          <tbody >
            <tr>
                <td colspan="4"><center><b>Cukai Tanah Terlibat (Dari Resit Pembayaran)</b></center></td>
            </tr>
            <tr v-for="cua in cukais" v-if="cukais!=null">
              <td
                style="text-align: left"
              >
                {{ cua.kodAkaun }}
              </td>
              <td

                style="text-align: left"
              >
                {{ cua.butiran }}
              </td>
              <td
                style="text-align: right"
              >
                {{ moneyFormat(cua.amaunDebit) }}
              </td>
              <td
                style="text-align: right"
              >
                {{ moneyFormat(cua.amaunKredit) }}
              </td>
            </tr>

            <tr>
                <td colspan="4"><center><b>Cukai Pelarasan</b></center></td>
            </tr>
          <tr v-for="cuak in pelarasan" v-if="pelarasan.length!=0">
            <!-- <td  style="text-align: left">
              {{ this.shm.no_hm }}
            </td> -->
            <td  style="text-align: left">
              {{ cuak.kodAkaun }}
            </td>
            <td  style="text-align: left">
              {{ cuak.keterangan }}
            </td>
            <td  style="text-align: right">
              {{ cuak.amaunDebit ? moneyFormat(cuak.amaunDebit) : 0 }}
            </td>
            <td  style="text-align: right">
              {{ cuak.amaunKredit ? moneyFormat(cuak.amaunKredit) : 0 }}
            </td>
          </tr>
          <tr v-else>
            <td colspan="4">
                <div class="w-card__content content-hardcode">
                    <center>Tiada Pelarasan Dibuat</center>
                </div>
            </td>
          </tr>
          <!-- <tr>
            <td colspan="4"><center><b>Resit Bayaran</b></center></td>
          </tr> -->
          <!-- <tr v-for="bayar in cukais.terimaan" v-if="cukais.terimaan.length!=0">
            <td   v-if="parseFloat(bayar.tahun_bayar) == newYear && bayar.kod_status=='K'">No Resit : {{ bayar.no_resit }}</td>
            <td align="right"  v-if="parseFloat(bayar.tahun_bayar) == newYear && bayar.kod_status=='K'"></td>
            <td align="right"  v-if="parseFloat(bayar.tahun_bayar) == newYear && bayar.kod_status=='K'">0.00</td>
            <td align="right"  v-if="parseFloat(bayar.tahun_bayar) == newYear && bayar.kod_status=='K'">{{ Number(bayar.amaun ).toFixed(2)}}</td>
          </tr>
          <tr v-else>
            <td colspan="4">
                <div class="w-card__content content-hardcode">
                    <center>Tiada Bayaran Dibuat</center>
                </div>
            </td>
          </tr> -->
          <tr>
            <td colspan="2"><b>JUMLAH</b></td>
            <td align="right"><b>{{this.cukaiTotal.debit}}</b></td>
            <td align="right"><b>{{this.cukaiTotal.kredit}}</b></td>
          </tr>
          <tr>
            <td colspan="2" ><b>Amaun Debit - Amaun Kredit</b></td>
            <td colspan="2" align="right"><b>{{this.cukaiTotal.total}}</b></td>
          </tr>
          </tbody>
        </table>
        <center><w-spinner :model-value="searching" /></center>
      </w-card>
      <br />
      <w-card v-for="shm in senaraiHm">
        <w-flex class="justify-space-between">
          <h4>No Hakmilik: {{ shm.no_hm }}</h4>
          <w-button class="ml3" @click="onPelarasan('2',shm,newYear)" :loading="searching"> Tambah Cukai Pelarasan </w-button>
        </w-flex>
        <SenaraiTable :shm="shm" />
        <center><w-spinner :model-value="searching" /></center>
      </w-card>
      <br />
      <!-- <w-flex class="justify-end">
        <w-button
          bg-color="success"
          class="ml3"
          @click="tambahPelarasan = true"
        >
          Hantar
        </w-button>
      </w-flex> -->
    </w-card>
    <br>
    <w-card title="Jumlah Keseluruhan">

        <table class="mb2 table-dashboard" width="100%">
          <thead>
            <tr>
              <!-- <td>No Hm</td> -->
              <td>Amaun Debit (RM)</td>
              <td>Amaun Kredit (RM)</td>
              <td>Jumlah (Amaun Debit- Amaun Kredit)</td>
            </tr>
          </thead>
          <tbody>
                <tr>
                    <td align="right"><b><h5>{{ moneyFormat(this.jumlahSemua.debit) }}</h5></b></td>
                    <td align="right"><b><h5>{{ moneyFormat(this.jumlahSemua.kredit) }}</h5></b></td>
                    <td align="right"><b><h5>{{ moneyFormat(this.jumlahSemua.total) }}</h5></b></td>
                </tr>
          </tbody>
        </table>
        <center><w-spinner :model-value="searching" /></center>
      </w-card>
    <TambahPelarasanDialog
      v-if="tambahHakmilik"
      :show="tambahHakmilik"
      @close="tambahHakmilik = false"
      :onSemak="onSemak"
      :form="form"
      :searching="searching"
    />
    <TambahCukaiDialog
      v-if="tambahPelarasan"
      :tambahPelarasan="tambahPelarasan"
      @close="tambahPelarasan = false"
      :addCukaiPelarasan="addCukaiPelarasan"
      :searching="searching"
      :submitPelarasan="submitPelarasan"
    />
  </layout>
</template>
  <script>
import ZResource from "@/Modules/z-resource";
import _ from "lodash";
import { moneyFormat } from "../helper/index.js";
import WaveUI from "wave-ui";
import moment from "moment";
import Table from "../../Component/Table.vue";
import TambahPelarasanDialog from "./Component/TambahPelarasanDialog.vue";
import TambahCukaiDialog from "./Component/TambahCukaiDialog.vue";
import SenaraiTable from "./Component/senaraiCukaiTable.vue";
export default {
  extends: ZResource,
  components: {
    TambahPelarasanDialog,
    TambahCukaiDialog,
    SenaraiTable,
    Table,
  },
  data() {
    const d = new Date();
    const c = d.getFullYear();
    return {
      waveui: new WaveUI(),
      masuk: false,
      tambahHakmilik: false,
      validators: { required: (value) => !!value || "Sila Isi Ruangan Ini" },
      districts: [{ label: "Loading", selected: true }],
      mukim: [{ label: "Loading", selected: true }],
      jhm: [{ label: "Loading", selected: true }],
      kod_lot: [{ label: "Loading", selected: true }],
      apiBaseUrl: process.env.MIX_API_BASE_URL,
      searching: false,
      form: {
        noResit: null,
      },
      senarai: {
        noResit: null,
        tarikhBayar: null,
        noHakmilik: null,
      },
      renderComponent: false,
      success: null,
      hakMilik: [],
      pemilikSPTB: [],
      tambahPelarasan: false,
      hmTersebut: [
        {
          hm: null,
          akaun: null,
          butiran: null,
          amaunDebit: null,
          amaunKredit: null,
        },
      ],
      cukais: [],
      form: {
        kod_daerah: "01",
        form_option: "option1",
        kategori_carian: "1",
        barcode: null,
      },
      senaraiCukai: [],
      senaraiHm: [],
      pelarasan:[],
      cukaiPelarasan: {
        tahun: c,
        akaun_id: null,
        amaun_debit: null,
        amaun_kredit: null,
        },
     cukaiTotal:{
        debit:null,
        kredit:null,
        total:null,
     },
     cukaiTotals:{
        debit:null,
        kredit:null,
        total:null,
     },
     jumlahSemua:{
        debit:0,
        kredit:0,
        total:0,
     }
    };
  },
  computed: {
    newYear() {
      // const y
      const d = new Date();
      let c = d.getFullYear();
      return c;
    },
  },
  methods: {
    moneyFormat,
    async resit() {
      this.searching = true;
      await axios({
        method: "get",
        url: `${this.apiBaseUrl}/lkp/resit?no_resit=${this.form.noResit}`,
        responseType: "json",
      }).then((e) => {
        this.senarai.noResit = e.data.resit.no_resit;
        this.senarai.hm_akaun_id = e.data.resit.model_id;
        this.senarai.tarikhBayar = moment(e.data.resit.tarikh_bayar).format(
          "DD-MM-YYYY"
        );
        this.senarai.noHakmilik = e.data.resit.no_rujukan;
        this.cukais = e.data.resitButiran.map((d) => {
          return {
            id:d.id,
            kodAkaun:d.akaun_id.kod,
            butiran:d.akaun_id.keterangan,
            amaunDebit:0,
            amaunKredit:d.amaun,
          };
        });
        this.searching = false;
        this.getCukai();
      });
    },
    async getCukai() {
      this.searching = true;
    //   const l = {
    //     kategoriCarian: "1",
    //     formOption: "option1",
    //     barcode: this.senarai.noHakmilik,
    //     kodDaerah: "01",
    //   };
    //   await axios({
    //     method: "post",
    //     url: `${this.apiBaseUrl}/cukai/cari`,
    //     responseType: "json",
    //     data: l,
    //   })
    //     .then((e) => {
    //       if (e.data.length > 0) {
    //         this.cukais = e.data;
    //       }
    //     });

        await axios({
            method: "get",
            url: `${this.apiBaseUrl}/pelarasan/checkPelarasan?hm_akaun_id=${this.senarai.hm_akaun_id}`,
            responseType: "json",
        }).then((e) => {
            this.senaraiCukai = e.data.map((d) => {
              return {
                id:d.id,
                akaun_id:d.akaun_id.id,
                kodAkaun:d.akaun_id.kod,
                keterangan:d.akaun_id.keterangan,
                amaunDebit: d.amaun_debit,
                amaunKredit: d.amaun_kredit,
              };
            });
            this.pelarasan = this.senaraiCukai;
        });

        await axios({
            method: "get",
            url: `${this.apiBaseUrl}/pelarasan/kiraPelarasanResit/${this.senarai.noResit}?id=${this.senarai.hm_akaun_id }`,
            responseType: "json",
        }).then((e) => {
            this.cukaiTotal.debit=e.data.debit;
            this.cukaiTotal.kredit=e.data.kredit;
            this.cukaiTotal.total=e.data.total;
        })
        .finally((e) => {
            this.form.barcode=null;
            this.tambahHakmilik=false;
            this.searching = false;
            this.hasSearched = true;
            this.senaraiCukai=[];
            this.jumlah();
        });

    },
    async getTotal($x){
        await axios({
            method: "get",
            url: `${this.apiBaseUrl}/pelarasan/kiraPelarasan?id=${$x}`,
            responseType: "json",
        }).then((e) => {
            this.senaraiHm.find(element=>element.hm_akaun_id==$x).debit=0;
            this.senaraiHm.find(element=>element.hm_akaun_id==$x).kredit=0;
            this.senaraiHm.find(element=>element.hm_akaun_id==$x).total=0;

            this.senaraiHm.find(element=>element.hm_akaun_id==$x).debit=e.data.debit;
            this.senaraiHm.find(element=>element.hm_akaun_id==$x).kredit=e.data.kredit;
            this.senaraiHm.find(element=>element.hm_akaun_id==$x).total=e.data.total;
            console.log(this.senaraiHm.find(element=>element.hm_akaun_id==$x));
        })
        .finally((e) => {
            this.form.barcode=null;
            this.tambahHakmilik=false;
            this.searching = false;
            this.hasSearched = true;
            this.senaraiCukai=[];
            this.jumlah();
        });
    },
    async onSemak() {
      this.searching = true;
       const l = {
        kategoriCarian: "1",
        formOption: "option1",
        barcode: this.form.barcode,
        kodDaerah: "01",
      };
      await axios({
        method: "post",
        url: `${this.apiBaseUrl}/cukai/cari`,
        responseType: "json",
        data: l,
      })
        .then((e) => {
          if (e.data != null) {
            this.senaraiHm = [
              ...this.senaraiHm,
              {
                no_hm: e.data[0].no_hm,
                hm_akaun_id: e.data[0].id,
                cukai:e.data[0].cukais,
                pelarasan:[],
                terimaan:e.data[0].terimaan ?? [],
              },
            ];
          }
        //   this.getTotal(e.data[0].id);
          this.senaraiPelarasan(e.data[0].id);
          // this.senaraiPelarasan(e.data.id);
        })
        .finally((e) => {
          this.form.barcode = null;
          this.tambahHakmilik = false;
          this.searching = false;
          this.hasSearched = true;

        });
    },
    async senaraiPelarasan($x){
        await axios({
            method: "get",
            url: `${this.apiBaseUrl}/pelarasan/checkPelarasan?hm_akaun_id=${$x}`,
            responseType: "json",
        }).then((e) => {
            this.senaraiCukai = e.data.map((d) => {
              return {
                id:d.id,
                akaun_id:d.akaun_id.id,
                kodAkaun:d.akaun_id.kod,
                keterangan:d.akaun_id.keterangan,
                amaunDebit: d.amaun_debit,
                amaunKredit: d.amaun_kredit,
              };
            });
            this.senaraiHm.find(element=>element.hm_akaun_id==$x).pelarasan=[];
            this.getTotal($x);

            this.senaraiHm.find(element=>element.hm_akaun_id==$x).pelarasan=this.senaraiCukai;
        });
    },
    onPelarasan($x,$y,$z){
        this.addCukaiPelarasan={
            no_hm:$y.no_hm ?? $y.noHakmilik,
            i:$x,
            tahun:$z,
            akaun_id:null,
            amaun_debit:null,
            amaun_kredit:null,
            hm_akaun_id:$y.hm_akaun_id ?? $y.id,
        };
        this.tambahPelarasan=true;
    },
    async submitPelarasan(){
        this.searching = true;
      await axios({
        method: "post",
        url: `${this.apiBaseUrl}/pelarasan/addPelarasan`,
        responseType: "json",
        data: this.addCukaiPelarasan,
      }).then((e) => {
          if (e.data != null) {
            if(e.data.stat==2){
                this.senaraiPelarasan(e.data.akaunid);
            }
            else if(e.data.stat==1){
                this.senarai.noHakmilik =this.cukais[0].no_hm;
                this.getCukai();
            }
          }
        })
        .finally((e) => {
        //   this.form.barcode = null;
        //   this.tambahHakmilik = false;
        //   this.searching = false;
        //   this.hasSearched = true;
          this.tambahPelarasan=false;
        });
    },
    jumlah(){
        let amaunDebit = 0;
        let amaunKredit = 0;
        let total = 0;
        console.log(this.senaraiHm);
        this.senaraiHm.forEach(item => {
          if (item.total) {
            amaunDebit += parseFloat(item.debit); // Convert to floating-point number
            amaunKredit += parseFloat(item.kredit); // Convert to floating-point number
            total += parseFloat(item.total); // Convert to floating-point number
          }
        });
        this.jumlahSemua.debit = amaunDebit + parseFloat(this.cukaiTotal.debit); // Convert to floating-point number
        this.jumlahSemua.kredit = amaunKredit + parseFloat(this.cukaiTotal.kredit); // Convert to floating-point number
        this.jumlahSemua.total = total + parseFloat(this.cukaiTotal.total); // Convert to floating-point number

    }
  },
  created: function () {
    this.moment = moment;
  },
};
</script>
